import script from "./ChatItemSliding.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatItemSliding.vue?vue&type=script&setup=true&lang=ts"

import "./ChatItemSliding.vue?vue&type=style&index=0&id=6bcb6d01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcb6d01"]])

export default __exports__